import axios from "axios";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
export default function SetupForm() {
  const { code, list, api, user } = useParams();

  const iptvListDecoded = list ? decodeURIComponent(list) : "";
  const tmdbKeyDecoded = api ? decodeURIComponent(api) : "";
  const userDecoded = user ? decodeURIComponent(user) : "";
  const [lista, setLista] = useState(iptvListDecoded);
  const [apiKey, setApiKey] = useState(tmdbKeyDecoded);
  const [usuario, setUsuario] = useState(userDecoded);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    // Validar campos
    if (!lista || !apiKey || !usuario) {
      setMessage("Todos los campos son obligatorios.");
      return;
    }

    try {
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/xuxaweatv/sendForm`,
          {
            lista,
            apiKey,
            usuario,
            code,
          },
        )
        .then(({ data }) => {
          toast.success("Datos guardados correctamente");
        })
        .catch(({ response }) => {
          toast.error("Error al enviar datos");
          throw new Error(response);
        });
    } catch (err) {
      console.error(err);
      setMessage("Error de conexión con el servidor.");
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "50px auto",
        fontFamily: "sans-serif",
        marginTop: "80px",
      }}
    >
      <h2 className="text-center">Configurar XUXAWEA TV</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "10px" }}>
          <label>Lists IPTV:</label>
          <input
            type="text"
            className="form form-control"
            value={lista}
            onChange={(e) => setLista(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>TMBD API Key:</label>
          <input
            type="text"
            className="form form-control"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div style={{ marginBottom: "10px" }}>
          <label>Usuario XuxaweaTV:</label>
          <input
            type="text"
            className="form form-control"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            style={{ width: "100%", padding: "6px", marginTop: "4px" }}
          />
        </div>
        <div className="text-center">
          <Button variant="primary" type="submit">
            Enviar
          </Button>
        </div>
      </form>
      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
}
